var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpened)?_c('TaskViewChecklistPopup',{on:{"submit":_vm.submit,"close":function($event){return _vm.$emit('close')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }